// A toast that outlives the page that asked for it (APS-401): deleting a project moves to
// another page, and canceling a deletion swaps the shell's note for the page, so the page that
// acted is gone when its toast should show. `flash` leaves the text for whichever page shows
// toasts next (the shell, or the new-project page outside it); a text nobody took within a few
// seconds is dropped, never shown late.
import { useEffect } from 'react'

const FRESH_MS = 5_000

let pending: { text: string; at: number } | undefined
const takers = new Set<() => void>()

export function flash(text: string): void {
  pending = { text, at: Date.now() }
  for (const take of takers) take()
}

/** Shows a flashed text with `show`, now if one is waiting, and whenever one comes. */
export function useFlash(show: (text: string) => void): void {
  useEffect(() => {
    const take = () => {
      const next = pending
      pending = undefined
      if (next && Date.now() - next.at < FRESH_MS) show(next.text)
    }
    take()
    takers.add(take)
    return () => {
      takers.delete(take)
    }
  }, [show])
}
